import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wl-qbo-authentication-landing',
  templateUrl: './qbo-authentication-landing.component.html',
  styleUrls: ['./qbo-authentication-landing.component.less'],
    standalone: false
})
export class QboAuthenticationLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
